import React from "react"

export default function FieldEstimate_FormValueNotEmpty(props:any) {

    const valueClasses = Classes("ui5-txt-default ui5-field-form-editable dropdown-form h-36", props.className)

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {gd.utils.minutesHumanize(props.value)}
            </div>
            {props.children}
        </React.Fragment>
    )
}
